import { Injector }      from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { UIRouter }      from '@uirouter/core';

import { JsonService }    from '../../app-lite/core/services/json.service';
import { SessionModel }   from '../../app-lite/sessions/models/session';
import { SessionService } from '../../app-lite/sessions/session.service';

export function RouterConfig (
  router  : UIRouter,
  injector: Injector
) : void {
  router.transitionService.onBefore({}, () => {
    const cookieService  : CookieService  = injector.get(CookieService);
    const jsonService    : JsonService    = injector.get(JsonService);
    const sessionService : SessionService = injector.get(SessionService);

    const queryParameters = jsonService.getQueryParameters();

    if ( queryParameters.puppet || cookieService.get('puppetUser') ) {
      return sessionService.validate()
        .then(() => sessionService.refresh())
        .then(( session : SessionModel ) => session.subscription_status === 'canceled' || session.subscription_status === 'trial_ended'
          ? '/activate.html?puppet=true'
          : sessionService.getAndSetRights()
            .then(rights => {
              if ( session.company_settings.dealer ) {
                return '/dealer.html?puppet=true';
              }
              else if ( session.company_settings.first_login ) {
                return '/workshop.html#/company?puppet=true&first_login=true';
              }
              else if ( session.super_user ) {
                return '/workshop.html#/admin_dashboard?puppet=true';
              }
              else {
                return '/workshop.html?puppet=true';
              }
            }))
        .then(( href : string ) => {
          window.location.assign(href);

          return false;
        })
        .catch(() => {
          sessionService.clear();

          return true;
        });
    }
    else if ( sessionService.sessionID() && !queryParameters.disconnect ) {
      return sessionService.validate()
        .then(() => sessionService.refresh())
        .then(() => {
          window.location.assign(
            sessionService.company().dealer
              ? '/dealer.html#/'
              : '/workshop.html#/'
          );

          return false;
        })
        .catch(() => true);
    }
  });
}
